var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"inc"},[_c('el-container',[_c('div',{staticClass:"logo"},[_c('img',{staticClass:"logo-image",attrs:{"src":require("./assets/images/bodylogo.png"),"alt":""}})]),_c('Header'),_c('router-view')],1),_c('Footer')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }